




import Vue from "vue";
import { Component } from "vue-property-decorator";
import { deleteToken, retrieveToken, tokenValid } from "@/services/AuthService";
import Modal from "../../shared/modal/Modal.vue";
import { _keycloak } from "@/bootstrap";
import store from "@/vuex/store";

@Component({
  components: {
    MbeModal: Modal
  }
})
export default class LoginDentalPro extends Vue {
  mounted() {
    if (this.$route.query.token) {
      // console.log("should redirect to login");
    } else {
      // console.log("Keycloak is authenticated? " + _keycloak.authenticated);
      if (!_keycloak.authenticated) {
        let hasLogout = this.$route.query.logout === "true";

        const redirectUri = `${window.location.origin}/login`;
        // console.log("Keycloak is NOT authenticated");
        //console.log({redirectUri});
        const deleteRedirect = "/dental-pro/login?logout=true";

        const isTokenValid = tokenValid(null);
        const token = retrieveToken();

        if (isTokenValid && token) {
          deleteToken(deleteRedirect);
        } else {
          hasLogout = true;
        }

        if (hasLogout) {
          _keycloak.login({
            idpHint: "dental-pro",
            redirectUri: redirectUri,
            prompt: "login"
          });
        }
      } else {
        // console.log("Keycloak is authenticated");
      }
    }
  }
}
